"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SberbankIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("../../SvgIcon"));

var _ref = /*#__PURE__*/_react.default.createElement("path", {
  d: "M10,9.75,17.12,4.5A8.67,8.67,0,0,1,18.05,6l.15.32-8.2,6L6.57,10.18V7.6Zm6.92.07V10a6.93,6.93,0,1,1-3-5.71L15.65,3l-.22-.18A9,9,0,1,0,19,10a9.45,9.45,0,0,0-.14-1.61ZM0,20V0M20,20V0"
});

function SberbankIcon(props) {
  return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    viewBox: "0 0 20 20"
  }, props), _ref);
}

SberbankIcon.displayName = 'SberbankIcon';
SberbankIcon.defaultProps = {
  color: '#22A330'
};
SberbankIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes.default.string
} : {};